// AUTOGENERATED
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dAnalytics$dTypes$dItem from "../Restaumatic.Analytics.Types.Item/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
const BeginCheckout = x => x;
const newtypeBeginCheckout_ = {Coercible0: () => {}};
const hasFieldBeginCheckout = dictHasField => dictHasField;
const eqBeginCheckout = {eq: x => y => Data$dEq.eqArrayImpl(Restaumatic$dAnalytics$dTypes$dItem.eqItem.eq)(x.items)(y.items)};
const genericBeginCheckout = {to: x => x, from: x => x};
const showBeginCheckout = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Restaumatic$dAnalytics$dTypes$dItem.showItem.show);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["items", $0(v.items)]))([]);
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "BeginCheckout"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeBeginCheckout = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "items"})({
      unsafeDecode: Unscramble.decodeArray(Restaumatic$dAnalytics$dTypes$dItem.unscrambleDecodeItem.unsafeDecode)
    })(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeBeginCheckout = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericBeginCheckout)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "BeginCheckout"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "items"})((() => {
      const $0 = Data$dFunctor.arrayMap(Restaumatic$dAnalytics$dTypes$dItem.encodeItem.encode);
      return {encodeWithOptions: v => $0};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeBeginCheckout = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericBeginCheckout)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "BeginCheckout"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "items"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dAnalytics$dTypes$dItem.decodeItem);
    return {decodeWithOptions: v => $0.decode};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  BeginCheckout,
  decodeBeginCheckout,
  encodeBeginCheckout,
  eqBeginCheckout,
  genericBeginCheckout,
  hasFieldBeginCheckout,
  newtypeBeginCheckout_,
  showBeginCheckout,
  unscrambleDecodeBeginCheckout
};
